"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, Upload, Receipt, Calculator, Briefcase, Cloud, BookOpen, FileSpreadsheet } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CloudSolutions() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const softwareOptions = [{
    icon: FileText,
    name: "Xero",
    description: "Comprehensive cloud accounting platform with real-time collaboration, invoicing, and powerful reporting capabilities."
  }, {
    icon: Upload,
    name: "HubDoc",
    description: "Seamlessly capture and process receipts and documents, automatically syncing data to your accounting software."
  }, {
    icon: Receipt,
    name: "Dext\n",
    description: "(prev. Receipt Bank) Intelligent receipt and invoice management with OCR technology for automated data extraction and bookkeeping."
  }, {
    icon: Calculator,
    name: "Quickbooks",
    description: "Industry-leading accounting software with comprehensive features for invoicing, expenses, and financial management."
  }, {
    icon: Briefcase,
    name: "FreeAgent",
    description: "Designed for freelancers and small businesses, offering intuitive accounting, tax estimation, and project tracking."
  }, {
    icon: Cloud,
    name: "SageCloud",
    description: "Trusted cloud accounting solution with robust features for managing finances, invoicing, and business insights."
  }, {
    icon: BookOpen,
    name: "ClearBooks",
    description: "Simple yet powerful cloud accounting software with automated workflows and comprehensive financial reporting."
  }, {
    icon: FileSpreadsheet,
    name: "Zoho Books",
    description: "Integrated accounting platform with automated workflows, inventory management, and multi-currency support."
  }];
  return <section id="cloudsolutions" className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4 max-w-7xl">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-[var(--duration-medium)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-[36px] md:text-[48px] leading-[1.2] font-bold tracking-[-0.2px] text-foreground mb-6">Cloud Accounting Software&nbsp;</h2>
          <p className="text-[16px] leading-[1.6] text-muted-foreground mb-8">
            Choose from our wide range of supported cloud accounting platforms. Each solution offers powerful features to streamline your financial management and enhance business efficiency.
          </p>
          
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-[var(--duration-medium)] ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {softwareOptions.map((software, i) => {
          const IconComponent = software.icon;
          return <Card key={i} data-index={i} className="card group">
                <CardHeader>
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-[var(--radius-md)] bg-primary-light mb-4 group-hover:bg-primary/10 transition-colors duration-[var(--duration-medium)]">
                    <IconComponent className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-[22px] leading-[1.5] font-semibold text-foreground">
                    {software.name}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-[16px] leading-[1.6] text-muted-foreground">
                    {software.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}